import { Link } from "@tanstack/react-router";
import { ChevronRight } from "lucide-react";
import { analytics, type LandingCtaLocation } from "#/lib/analytics";
import { cn } from "#/lib/utils.ts";
import { featuredSymbol } from "./constants/content.ts";

type Props = {
	label: string;
	/** Which CTA fired this — attributes the click in analytics. */
	location: LandingCtaLocation;
	symbol?: string;
	className?: string;
};

export function LandingPrimaryCta({
	label,
	location,
	symbol = featuredSymbol,
	className,
}: Props) {
	return (
		<Link
			to="/trade/$symbol"
			params={{ symbol }}
			onClick={() => analytics.track("cta_clicked", { location })}
			className={cn(
				"inline-flex items-center gap-1 rounded-full bg-primary px-6 py-3 text-body2-bold text-primary-foreground transition border border-[var(--color-theme-static-black)]/10 dark:border-[var(--color-theme-static-white)]/10 hover:-translate-y-0.5 hover:bg-primary-hover",
				className,
			)}
		>
			<span className="relative z-[1]">{label}</span>
			<ChevronRight className="relative z-[1] h-4 w-4" />
		</Link>
	);
}
